<template>
  <div>
    <div class="wallet-banner">
      <div class="d-flex align-items-start">
        <div class="me-4">
          <img
            src="/assets/images/wallet/profile-pic.png"
            alt=""
            class="profile-pic"
          />
        </div>

        <div class="flex-grow-1 ml-4">
          <div class="d-flex align-items-center mb-3">
            <img
              src="/assets/images/wallet/INDIA.png"
              alt=""
              class="country-flag"
            />
            <h2 class="user-name me-3 mb-0">John Anderson</h2>
            <span class="badge ml-4">
              <img
                src="/assets/images/wallet/pending.png"
                alt="In progress"
                class="pending-sign"
              />
              verification in progress
            </span>
          </div>

          <div class="row balance-info p-3 align-items-center">
            <div class="col-md-8">
              <h3 class="total mb-2">Total Balance</h3>
              <p class="balance-value mb-3">0.000000 BTC</p>
              <p class="usd-value mb-4">= $0.00 USD</p>
            </div>
          </div>

          <p class="update-date mt-2">Last updated: Today, 14:45 PM</p>
        </div>
      </div>
    </div>

    <div class="overview-section">
      <h5 class="ml-3 mb-3">Overview</h5>
      <div class="row g-4">
        <div class="col-md-4">
          <div
            class="overview-card p-4 d-flex justify-content-between align-items-center"
          >
            <div>
              <p class="card-heading mb-3">Total Withdrawals</p>
              <h4 class="mb-3 fw-bold num-value">
                0.00 <span class="text-secondary">BTC</span>
              </h4>
              <small class="text-muted">+0.00</small>
            </div>
            <div class="icon-circle bg-light">
              <img
                src="/assets/images/wallet/withdraws.png"
                alt="withdraw icon"
                width="24"
              />
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div
            class="overview-card p-4 d-flex justify-content-between align-items-center"
          >
            <div>
              <p class="card-heading mb-3">Pending Requests</p>
              <h4 class="mb-3 fw-bold num-value">0</h4>
              <small class="text-muted">0 Processing</small>
            </div>
            <div class="icon-circle bg-light">
              <img
                src="/assets/images/wallet/pending-request.png"
                alt="pending icon"
                width="24"
              />
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div
            class="overview-card p-4 d-flex justify-content-between align-items-center"
          >
            <div>
              <p class="card-heading mb-3">Completed Transactions</p>
              <h4 class="mb-3 fw-bold num-value">0</h4>
              <small class="text-muted">This month</small>
            </div>
            <div class="icon-circle bg-light">
              <img
                src="/assets/images/wallet/right-check.png"
                alt="completed icon"
                width="24"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VerificationRequest",
};
</script>

<style scoped>
.row {
  margin-left: 0px;
  margin-right: 0px;
}
.wallet-banner {
  background-color: #23292e;
  padding: 40px 60px;
}

.user-name {
  color: #fff;
  font-size: 24px;
}

.total {
  font-weight: 600;
  font-size: 16px;
  color: #000;
}

.balance-value {
  font-weight: 700;
  font-size: 40px;
  color: #000;
}
.btn {
  border-radius: 0px;
  color: #000;
  font-size: 20px;
  font-weight: 700;
  width: auto;
  padding: 6px 30px;
}

.usd-value {
  font-weight: 300;
  font-size: 16px;
  color: #000;
}

.update-date {
  color: #e2e6eb;
  font-size: 16px;
  font-weight: 300;
}

.pending-sign {
  width: 14px;
  height: 14px;
}

.badge {
  color: #fcb913;
  font-size: 16px;
  font-weight: 500;
  display: flex;
  align-content: center;
  flex-wrap: wrap;
  align-items: center;
  box-shadow: 0px 8px 11px 0px #00000040;
  background: #fcb9134d;
  border: 1px solid #fcb913;
  border-radius: 39px;
  padding: 6px 15px;
  gap: 4px;
}
.badge img {
  margin-right: 4px;
}

.profile-pic {
  width: 115px;
  height: 117px;
  border: 3px solid #373f45;
  border-radius: 50%;
  padding: 6px;
}
.card-heading {
  font-family: Inter;
  font-weight: 400;
  font-size: 16px;
}
.icon-circle {
  background-color: #e2e6eb !important;
}

.country-flag {
  width: 42px;
  height: 25px;
  margin-right: 12px;
}

.balance-info {
  background-color: #fff;
  border-radius: 6px;
}

.overview-section {
  background-color: #e2e6eb;
  padding: 48px 100px 176px 100px;
  font-family: Inter;
}
.overview-section h5 {
  font-family: Inter;
  font-weight: 700;
  font-size: 24px;
  line-height: 31.5px;
}

.overview-card {
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.05);
  background-color: #fff;
}
.num-value {
  font-weight: 700;
  font-size: 32px;
}

.icon-circle {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
